// Slice de notificaciones
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Lista de notificaciones
  notifications: [],
  // Información de paginación
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 20,
    hasNextPage: false,
    hasPrevPage: false,
  },
  // Filtros aplicados
  filters: {},
  // Conteo de notificaciones no leídas
  unreadCount: 0,
  // Estados de carga
  isLoadingNotifications: false,
  isLoadingUnreadCount: false,
  isMarkingAsRead: false,
  isCreating: false,
  // Estados de error
  error: null,
  unreadCountError: null,
  markAsReadError: null,
  createError: null,
};

const notificacionSlice = createSlice({
  name: "notificacion",
  initialState,
  reducers: {
    // Obtener notificaciones
    notificacionesSuccess: (state, action) => {
      state.notifications = action.payload.items || [];
      state.pagination = action.payload.pagination || initialState.pagination;
      state.filters = action.payload.filters || {};
      state.isLoadingNotifications = false;
      state.error = null;
    },
    notificacionesFailure: (state, action) => {
      state.isLoadingNotifications = false;
      state.error = action.payload;
    },
    setLoadingNotifications: (state, action) => {
      state.isLoadingNotifications = action.payload;
    },

    // Agregar más notificaciones (para "Cargar más")
    appendNotifications: (state, action) => {
      state.notifications = [...state.notifications, ...(action.payload.items || [])];
      state.pagination = action.payload.pagination || state.pagination;
      state.isLoadingNotifications = false;
      state.error = null;
    },

    // Obtener conteo de no leídas
    unreadCountSuccess: (state, action) => {
      state.unreadCount = action.payload;
      state.isLoadingUnreadCount = false;
      state.unreadCountError = null;
    },
    unreadCountFailure: (state, action) => {
      state.isLoadingUnreadCount = false;
      state.unreadCountError = action.payload;
    },
    setLoadingUnreadCount: (state, action) => {
      state.isLoadingUnreadCount = action.payload;
    },

    // Marcar como leída
    markAsReadSuccess: (state, action) => {
      const notificationId = action.payload;
      // Actualizar la notificación en la lista
      const notification = state.notifications.find(n => n.id === notificationId);
      if (notification) {
        notification.read = 1;
      }
      // Decrementar el contador de no leídas
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
      state.isMarkingAsRead = false;
      state.markAsReadError = null;
    },
    markAsReadFailure: (state, action) => {
      state.isMarkingAsRead = false;
      state.markAsReadError = action.payload;
    },
    setMarkingAsRead: (state, action) => {
      state.isMarkingAsRead = action.payload;
    },

    // Crear notificación
    createNotificacionSuccess: (state, action) => {
      state.isCreating = false;
      state.createError = null;
    },
    createNotificacionFailure: (state, action) => {
      state.isCreating = false;
      state.createError = action.payload;
    },
    setCreatingNotification: (state, action) => {
      state.isCreating = action.payload;
    },

    // Reset
    notificacionReset: (state) => {
      return initialState;
    },
  },
});

export const {
  notificacionesSuccess,
  notificacionesFailure,
  setLoadingNotifications,
  appendNotifications,
  unreadCountSuccess,
  unreadCountFailure,
  setLoadingUnreadCount,
  markAsReadSuccess,
  markAsReadFailure,
  setMarkingAsRead,
  createNotificacionSuccess,
  createNotificacionFailure,
  setCreatingNotification,
  notificacionReset,
} = notificacionSlice.actions;

export default notificacionSlice.reducer;
